import { memo, useContext } from 'react';

import { Props } from '@/components/shared/SnoozedUntil/types';
import TaskSnoozedUntil from '@/components/TaskSnoozedUntil';
import { Color } from '@/constants/color';
import PersonContext from '@/pages/Person/PersonContext';
import DualTime from '@/ui/components/DualTime/DualTime';
import Popover from '@/ui/components/Popover';

const SnoozedUntil = ({ item, updateItem }: Props) => {
  const { person } = useContext(PersonContext);

  if (item.status === 'snoozed' && item.snoozed_until) {
    return (
      <span className="m-1">
        <Popover
          buttonColor={Color.GRAY}
          buttonRound
          buttonSize="xs"
          popoverButtonText={
            <>
              <span className="mr-0.5">Snoozed Until:</span>
              <DualTime dateTime={new Date(item.snoozed_until)} memberTZ={person.time_zone} />
            </>
          }>
          <TaskSnoozedUntil
            itemId={item.id}
            snoozedUntil={item.snoozed_until}
            updateItem={updateItem}
          />
        </Popover>
      </span>
    );
  }

  return null;
};

export default memo(SnoozedUntil);
